/**
 * Download data as a JSON file
 * @param data - The data to download (will be JSON stringified)
 * @param filename - The name of the file (default: 'output.json')
 */
export function download_json_as_file(data: any, filename: string = 'output.json'): void {
    const jsonString = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    console.log('File downloaded:', filename);
}

/**
 * Copy data to clipboard with fallback support
 * @param data - The data to copy (will be JSON stringified)
 */
export function copy_to_clipboard(data: any): void {
    const schemaJSON = JSON.stringify(data, null, 2); // Pretty format
    console.log(schemaJSON); // Log to check output

    if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
        // ✅ Modern approach using Clipboard API
        navigator.clipboard.writeText(schemaJSON)
            .then(() => console.log("Schema copied successfully!"))
            .catch(err => {
                console.error("Failed to copy schema:", err);
                alert("Failed to copy. Please try again.");
            });
    } else {
        // 🚀 Safe fallback without using `execCommand`
        const textArea = document.createElement("textarea");
        textArea.value = schemaJSON;

        // Position absolutely to current scroll position to prevent scrolling
        const scrollY = window.pageYOffset || document.documentElement.scrollTop;
        textArea.style.position = "absolute";
        textArea.style.top = `${scrollY}px`;
        textArea.style.left = "-9999px";
        textArea.style.opacity = "0";
        textArea.style.pointerEvents = "none";
        textArea.setAttribute('readonly', '');
        textArea.readOnly = false;

        document.body.appendChild(textArea);

        // Store current scroll position
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;

        // Select the text
        textArea.focus();
        textArea.select();

        // Restore scroll position immediately
        window.scrollTo(scrollLeft, scrollTop);

        try {
            const successful = document.execCommand("copy");
            console.log("Copied using fallback method:", successful);
            if (!successful) {
                alert("Copy failed. Please try again.");
            }
        } catch (err) {
            console.error("Fallback copy failed:", err);
            alert("Clipboard copy not supported in your browser.");
        }

        document.body.removeChild(textArea);
    }
}
